let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8EWvC")).then(() => parcelRequire('67zLr'));